export const START_PROGRESS_VALUE = 0;
export const FINISH_PROGRESS_VALUE = 0.999;
export const STEP_PROGRESS = 0.00000000001;